var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"md-card md-card-testimonial"},[_c('div',{staticClass:"md-card-header icon"},[_c('i',{staticClass:"material-icons"},[_vm._t("header-icon")],2)]),_c('div',{staticClass:"md-card-content"},[_vm._t("content")],2),_c('div',{staticClass:"md-card-actions",staticStyle:{"justify-content":"flex-start"}},[_vm._t("footer")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }